import $ from 'jquery';

import BaseItemView from 'app/src/views/base/BaseItemView';

import terminalDetailTemplate from './templates/terminal-detail-view.hbs';

const _Events = {
  TERMINAL_TYPE_CHANGED: 'terminal:type:changed',
};

// configure
let View = BaseItemView.extend({
  template: terminalDetailTemplate,

  ui: {
    inputs: 'input, select',
    terminalAttributes: '#terminal_attributes',
    terminalType: 'select[name=type]',
  },

  triggers: {
    'change @ui.terminalType': _Events.TERMINAL_TYPE_CHANGED,
  },
});

// define
export default class TerminalDetailView extends View {
  /**
   * Retrieves a hash of name value pairs for the data present in the terminal
   * configuration view.
   *
   * @returns {{}}
   */
  getInputValues() {
    let attributeValues = {};

    this.ui.inputs.each((index, element) => {
      let $input = $(element);
      attributeValues[$input.attr('name')] = $input.val();

      // We don't want to send blank values to the backend. If any
      // field is empty, don't send it as an attribute in the payload
      // at all.
      if (!attributeValues[$input.attr('name')]) {
        delete attributeValues[$input.attr('name')];
      }
    });

    return attributeValues;
  }

  /**
   * Performs the provided validation function.
   * @param validationFunction
   *
   * @returns {Boolean} The result of the validation function
   */
  static validate(validationFunction) {
    return validationFunction();
  }
}
